import { render, staticRenderFns } from "./verifyTab.vue?vue&type=template&id=2e9bffd6&scoped=true"
import script from "./verifyTab.vue?vue&type=script&lang=js"
export * from "./verifyTab.vue?vue&type=script&lang=js"
import style0 from "./verifyTab.vue?vue&type=style&index=0&id=2e9bffd6&lang=scss&scoped=true"
import style1 from "./verifyTab.vue?vue&type=style&index=1&id=2e9bffd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9bffd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9bffd6')) {
      api.createRecord('2e9bffd6', component.options)
    } else {
      api.reload('2e9bffd6', component.options)
    }
    module.hot.accept("./verifyTab.vue?vue&type=template&id=2e9bffd6&scoped=true", function () {
      api.rerender('2e9bffd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/accountManage/components/verifyTab.vue"
export default component.exports